<template>
  <div class="cr-detail-card__action">
    <button v-if="localQuantity === 0" @click="addToBasket({productId:product.id, quantity: product.ratio})" class="cr-button">
        <span class="cr-button__text">
          Добавить в корзину
        </span>
    </button>

    <div v-if="localQuantity === '' || localQuantity > 0" class="cr-detail-card__counter cr-counter cr-counter--second">
      <div class="cr-counter__wrapper">
        <button @click="handleDecrement(product.ratio)" class="cr-counter__button js-button-minus simulated-hover" type="button">
          <svg class="cr-counter__button-icon" width="14" height="14" viewBox="0 0 14 2">
            <use xlink:href="/assets/img/svg/sprite.svg#minus"></use>
          </svg>
        </button>
        <div class="cr-counter__inner">
          <input class="cr-counter__qty" type="number" data-step="1" v-model.number="localQuantity"
                 @input="handleInput"
                 min="0"
                 :max="product.available">
          <span class="cr-counter__sum">
              {{ formatPrice(localQuantity * product.price) }} ₽
            </span>
        </div>
        <button @click="handleIncrement(product.ratio)" class="cr-counter__button js-button-plus simulated-hover" type="button">
          <svg class="cr-counter__button-icon" width="14" height="14" viewBox="0 0 14 14">
            <use xlink:href="/assets/img/svg/sprite.svg#plus"></use>
          </svg>
        </button>
      </div>
      <button @click="handleIncrement(product.ratio*5)" class="cr-counter__button-plus js-boost-plus simulated-hover" data-value="5" type="button">
          <span class="cr-counter__icon-wrapper">
            <svg class="cr-counter__button-icon" width="14" height="14" viewBox="0 0 14 14">
              <use xlink:href="/assets/img/svg/sprite.svg#plus"></use>
            </svg>
          </span>
        5
      </button>
    </div>
  </div>
  <div v-if="!isSticky && localQuantity >= product.available" class="cr-detail-card__message cr-message cr-message--notification">
    Добавлено максимальное количество товара
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import num from "@/mixin/num.vue";
import product from "@/mixin/product.vue";
export default {
  mixins: [product],
  props: {
    product: {
      type: Object,
      required: true
    },
    isSticky: {
      type: Boolean,
      default: false
    }
  }

}
</script>
